'use strict';

var showGalleryArrows = function showGalleryArrows() {
  $('.js-productGallery').addClass('is-hovered');
};
var hideGalleryArrows = function hideGalleryArrows() {
  $('.js-productGallery').removeClass('is-hovered');
};

var galleryGoPrev = function galleryGoPrev() {
  var targetGallery = $('.js-productGallery_node.is-active').prev()[0] ? $('.js-productGallery_node.is-active').prev() : $('.js-productGallery_node').last();
  updateSlide(targetGallery);
};

var galleryGoNext = function galleryGoNext() {
  var targetGallery = $('.js-productGallery_node.is-active').next()[0] ? $('.js-productGallery_node.is-active').next() : $('.js-productGallery_node').first();
  updateSlide(targetGallery);
};

var updateSlide = function updateSlide(targetSlide) {
  // カレントスライド更新
  $('.js-productGallery_node.is-active').removeClass('is-active');
  targetSlide.addClass('is-active');

  // サムネ一覧のカレント更新
  var targetId = targetSlide.attr('data-media-id');
  updateCurrentThumbnail(targetId);
};

var updateCurrentThumbnail = function updateCurrentThumbnail(id) {
  $('.js-productList_nodeThumbnail').removeAttr('aria-current');
  $('[data-target="' + id + '"] .js-productList_nodeThumbnail').attr('aria-current', true);
};

var initGalleryControl = function initGalleryControl() {
  $('.js-productGallery').on('mouseenter', showGalleryArrows);
  $('.js-productGallery').on('mouseleave', hideGalleryArrows);
  $('.js-galleryArrow_prev').on('click', galleryGoPrev);
  $('.js-galleryArrow_next').on('click', galleryGoNext);
};

var initSwipeControl = function initSwipeControl() {
  var slider = $('.js-productGallery')[0];

  var startX = void 0;
  var startY = void 0;
  var distX = void 0;
  var distY = void 0;
  var threshold = 50; // スワイプを検出するための閾値
  var restraint = 100; // 垂直方向の移動を制限するための値
  var allowedTime = 300; // スワイプを検出するための最大時間
  var elapsedTime = void 0;
  var startTime = void 0;

  slider.addEventListener('touchstart', function (e) {
    var touchObj = e.changedTouches[0];
    startX = touchObj.pageX;
    startY = touchObj.pageY;
    startTime = new Date().getTime(); // タッチ開始時刻を記録
    // e.preventDefault();
  }, false);

  // slider.addEventListener('touchmove', (e) => {
  //   e.preventDefault(); // スクロールを防止
  // }, false);

  slider.addEventListener('touchend', function (e) {
    var touchObj = e.changedTouches[0];
    distX = touchObj.pageX - startX; // 水平方向の移動距離
    distY = touchObj.pageY - startY; // 垂直方向の移動距離
    elapsedTime = new Date().getTime() - startTime; // タッチ開始から終了までの時間

    if (elapsedTime <= allowedTime) {
      // スワイプ時間が許容範囲内か確認
      if (Math.abs(distX) >= threshold && Math.abs(distY) <= restraint) {
        // スワイプ距離と方向を確認
        if (distX > 0) {
          galleryGoPrev();
        } else {
          galleryGoNext();
        }
      }
    }
    e.preventDefault();
  }, false);
};

document.addEventListener('DOMContentLoaded', function () {
  if ($('.js-productGallery_node').length > 1) {
    initGalleryControl();
    initSwipeControl();
  }
});